import { truncateFieldValueToCharacterLimit } from './field-character-limits'

export const ORDER_FIELD_MAX_LENGTHS = {
  card_message: 255,
  signature: 255,
  special_instructions: 255,
  recipient_name: 255,
  recipient_phone: 255,
  recipient_email: 255,
  address_name: 255,
  address_line1: 255,
  address_line2: 255,
  address_city: 255,
  address_state: 255,
  // Order delivery is US-only today, so keep ZIP entry to 5 digits even though storage is wider.
  address_postal_code: 5,
}

// HTML maxLength counts UTF-16 code units; persisted/API limits count Unicode code points.
export const ORDER_FIELD_NATIVE_MAX_LENGTHS = {
  ...ORDER_FIELD_MAX_LENGTHS,
  card_message: ORDER_FIELD_MAX_LENGTHS.card_message * 2,
  signature: ORDER_FIELD_MAX_LENGTHS.signature * 2,
  special_instructions: ORDER_FIELD_MAX_LENGTHS.special_instructions * 2,
  recipient_name: ORDER_FIELD_MAX_LENGTHS.recipient_name * 2,
  recipient_email: ORDER_FIELD_MAX_LENGTHS.recipient_email * 2,
  address_name: ORDER_FIELD_MAX_LENGTHS.address_name * 2,
  address_line1: ORDER_FIELD_MAX_LENGTHS.address_line1 * 2,
  address_line2: ORDER_FIELD_MAX_LENGTHS.address_line2 * 2,
  address_city: ORDER_FIELD_MAX_LENGTHS.address_city * 2,
  address_state: ORDER_FIELD_MAX_LENGTHS.address_state * 2,
}

export function countOrderFieldCharacters(value: string | null | undefined): number {
  return Array.from(String(value ?? '')).length
}

export function isOrderFieldWithinLimit(
  field: keyof typeof ORDER_FIELD_MAX_LENGTHS,
  value: string | null | undefined
): boolean {
  return countOrderFieldCharacters(value) <= ORDER_FIELD_MAX_LENGTHS[field]
}

export function truncateOrderField<T>(
  field: keyof typeof ORDER_FIELD_MAX_LENGTHS,
  value: T
): T | string {
  return truncateFieldValueToCharacterLimit(value, ORDER_FIELD_MAX_LENGTHS[field])
}
